import ErrorBoundary from 'hb-react/shared/components/ErrorBoundary';
import { PaymentProvider } from 'hb-react/shared/components/Payment/context/PaymentContext';
import { Gateway } from 'hb-react/shared/components/Payment/Gateway';
import { useShoppingCard } from 'hb-react/shared/components/ShoppingCard/hooks/useShoppingCard';

export const PaymentGateway = ({ onSuccess }) => {
  const { data } = useShoppingCard();

  return (
    <ErrorBoundary>
      <PaymentProvider onSuccess={onSuccess} data={data}>
        <Gateway />
      </PaymentProvider>
    </ErrorBoundary>
  );
};
